import Vue from 'vue';
import Router from 'vue-router';
import HomePage from './components/Home.vue';
import PlayerPage from './components/Player.vue';
import LoginPage from './components/Login.vue';
import PaymentPage from './components/Payment.vue';
import RegisterPage from './components/Register.vue';
import PlayerHPage from './components/PlayerH.vue';
import MePage from './components/Me.vue';
import { getToken } from "@/utils";
Vue.use(Router);

const router = new Router({
	routes: [
		{ path: '/', component: HomePage },
		{ path: '/player', name: 'Player', component: PlayerPage, meta: { requiresAuth: true } },
		{ path: '/playerh', name: 'PlayerH', component: PlayerHPage, meta: { requiresAuth: true } },
		{ path: '/me', name: 'Me', component: MePage, meta: { requiresAuth: true } },
		{ path: '/login', component: LoginPage },
		{ path: '/register', component: RegisterPage },
		{ path: '/payment', component: PaymentPage, meta: { requiresAuth: true } }
	]
});

// 添加全局导航守卫
router.beforeEach((to, from, next) => {
	const isAuthenticated = getToken();

	if (to.matched.some(record => record.meta.requiresAuth)) {
		// 需要认证的路由
		if (!isAuthenticated) {
			console.log("to.fullPath", to.fullPath);
			next({
				path: '/login',
				query: { redirect: to.fullPath }  // 保存目标路由路径
			});
		} else {
			next();
		}
	} else {
		// 不需要认证的路由
		next();
	}
});

export default router; 